





















import Vue, { PropType } from "vue";
import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Checkbox",
  model: {
    prop: "checkedValues",
    event: "change"
  },
  props: {
    checkedValues: {
      type: Array as PropType<Props["checkedValues"]>,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Object] as PropType<Props["value"]>,
      required: true
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    isChecked() {
      return this.checkedValues.includes(this.value);
    },
    iconConfig() {
      if (this.isChecked) {
        return { name: "Checked", class: "checkbox__icon--checked" };
      } else {
        return this.hover
          ? { name: "Unchecked-Hover", class: "checkbox__icon--hover" }
          : { name: "Unchecked" };
      }
    }
  },
  methods: {
    toggleCheck() {
      if (this.isChecked) {
        this.removeValue();
      } else {
        this.addValue();
      }
    },
    addValue() {
      sendGaEvent(this, { gaEventLabel: { value: true, label: "チェック" } });
      const newCheckedValues = [...this.checkedValues, this.value];
      this.$emit("change", newCheckedValues);
    },
    removeValue() {
      sendGaEvent(this, {
        gaEventLabel: { value: false, label: "未チェック" }
      });
      const newCheckedValues = this.checkedValues.filter(e => e !== this.value);
      this.$emit("change", newCheckedValues);
    },
    onMouseover() {
      this.hover = true;
    },
    onMouseleave() {
      this.hover = false;
    }
  }
});
